import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { SimpleBlockContent } from "../../SimpleBlockContent";
import { Button } from "@components/Button";
import {} from "@components/ProductCard/hooks/useRating";
import { useMobileDetect } from "@hooks/index";
import { StyledWith } from "../StyledWith";
import styles from "./styles/view.module.css";
import { LogoAfterpay } from "@icons/logo-afterpay";
import * as currencyService from "@services/format/currency";

const ProductFormSummary = ({
  product,
  title,
  price,
  amount,
  currency,
  compareAtPrice,
  finalSale,
  description,
  openReviewsDrawer,
  styledWith,
  bundleLinks,
}) => {
  const rating = useRating(product);
  const { t } = useTranslation("productpage");
  const currentDevice = useMobileDetect();
  const isMobile = currentDevice.isMobile();

  console.log("RARES", price, compareAtPrice, amount);

  return (
    <div className={styles.productSummary}>
      <div>
        <div className={styles.productHeader}>
          <h2 className={styles.productTitle}>{title}</h2>
        </div>
        <div className={styles.productPriceReviews}>
          <div className={styles.productPrice}>
            <span>{price}</span>
            {compareAtPrice && (
              <span className={styles.priceCompareAt}>{compareAtPrice.replace(/[CA]/g, "")}</span>
            )}

            {finalSale && <span className="product-finalSale">{t("final-sale")}</span>}

            {rating && rating.average && (
              <span>
                {rating.average.toFixed(1)}/5{" "}
                {rating.count > 5 && `(${rating.count} ${t("reviews")})`}
              </span>
            )}
          </div>
          {rating && rating.average && (
            <Button
              variant="tertiary"
              handleClick={openReviewsDrawer}
              description="allReviews"
              descriptionText="Show reviews drawer"
            >
              {t("all-reviews-button")}
            </Button>
          )}
        </div>
        <div className={styles.productSezzle}>
          <span>
            {t("sezzle")} {currencyService.formatPrice(amount / 4, currency)} {t("with")}
          </span>
          <LogoAfterpay />
        </div>
      </div>
      {description}
      {bundleLinks && bundleLinks.length && <SimpleBlockContent blocks={bundleLinks} />}
      {styledWith && !isMobile && (
        <StyledWith customTitle={styledWith.customTitle} products={styledWith.products} />
      )}
    </div>
  );
};

ProductFormSummary.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  compareAtPrice: PropTypes.string,
  finalSale: PropTypes.bool.isRequired,
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default ProductFormSummary;
